@if (type !== 'link') {
  <button [class]="'button ' + classes" [type]="type" (click)="click($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
} @else if (type === 'link' && !href) {
  <a [class]="'button ' + classes" [routerLink]="route" [queryParams]="params" [fragment]="fragment" (click)="click($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else {
  <a [class]="'button ' + classes" [href]="href" [attr.target]="target" (click)="click($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}

<ng-template #content>
  <span class="button__content">
    <ng-content></ng-content>
  </span>
  @if (multiselect) {
    <div class="button__multiselect">
      <app-icon [icon]="'chevron-bold'" [width]="24" [rotate]="90"></app-icon>
    </div>
  }
</ng-template>
